import type { Channel } from 'types/masterData'

import { NUM_PRICES_TO_SHOW_TOOLTIP } from '../../components/price/Price'

export type GetShouldShowTooltipProps = {
	showDiscountInfo: boolean
	hasPriceHistory: boolean
	crossedOut: number[]
	channel: Channel
}

export const getShouldShowTooltip = ({
	showDiscountInfo,
	hasPriceHistory,
	crossedOut,
	channel,
}: GetShouldShowTooltipProps): boolean => {
	return (
		showDiscountInfo &&
		hasPriceHistory &&
		crossedOut.length >= NUM_PRICES_TO_SHOW_TOOLTIP[channel]
	)
}
